import zod from "zod";
import { ownerSchema } from "@/api/http/schemas/ownerSchemas";

export const fileSchema = zod.object({
  id: zod.number(),
  file_size: zod.number(),
  file_type: zod.string(),
  file_url: zod.string().url(),
  mime_type: zod.string(),
  original_name: zod.string(),
  owner_id: zod.number().nullable().optional(),
  offer_stip_id: zod.number().optional(),
  personal_information: ownerSchema.optional(),
  created_at: zod.string().datetime(),
  updated_at: zod.string().datetime(),
});

export type ApiFile = zod.infer<typeof fileSchema>;
